module.exports = __webpack_public_path__ + "assets/img/06.7e046e07.png";